module.exports = __webpack_public_path__ + "media/misc/button-base-9313056d.png";